export default {"src":"/_next/static/media/midea_logo.578709bf.svg","height":60,"width":155,"blurWidth":0,"blurHeight":0};